import { useAuthStore, type ApiMenuItem } from '@/stores/auth.store'
import { permissionDebugStore } from '../permission-debug-store'
import type { IssueBusinessContext } from './issue-package'

function normalizePath(path: string): string {
  const pathname = path.split(/[?#]/)[0] || '/'
  return pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
}

function findMenuTrail(items: ApiMenuItem[] | null | undefined, pathname: string, trail: ApiMenuItem[] = []): ApiMenuItem[] | undefined {
  for (const item of items ?? []) {
    const nextTrail = [...trail, item]
    if (normalizePath(item.path) === normalizePath(pathname)) return nextTrail
    const matchedChildren = findMenuTrail(item.children, pathname, nextTrail)
    if (matchedChildren) return matchedChildren
  }
  return undefined
}

function maskUserAccount(userAccount: string | undefined): string | undefined {
  if (!userAccount) return undefined
  return `${userAccount.slice(0, 2) || '*'}***`
}

export function getIssueBusinessContext(pathname: string): IssueBusinessContext | undefined {
  const authState = useAuthStore.getState()
  const currentPath = normalizePath(pathname)
  const currentEntries = permissionDebugStore.getEntries()
    .filter((entry) => normalizePath(entry.pathname) === currentPath)
  const systemCode = currentEntries[0]?.systemCode
    ?? Object.keys(authState.menuMap).find((code) => Boolean(findMenuTrail(authState.menuMap[code], currentPath)))
  const menuTrail = systemCode ? findMenuTrail(authState.menuMap[systemCode], currentPath)?.map((item) => item.meta.title) : undefined
  const operations = [...new Set(currentEntries.map((entry) => entry.permission ?? entry.action).filter((value): value is string => Boolean(value)))]
  const roles = systemCode ? authState.permissionsMap[systemCode]?.roles : undefined
  const userAccount = maskUserAccount(authState.user?.userAccount)
  const context = { systemCode, menuTrail, operations, userAccount, roles }

  return Object.values(context).some((value) => value && (!Array.isArray(value) || value.length > 0)) ? context : undefined
}
